import { render, staticRenderFns } from "./AppStoreLoading.vue?vue&type=template&id=7122ff73&scoped=true"
import script from "./AppStoreLoading.vue?vue&type=script&lang=js"
export * from "./AppStoreLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7122ff73",
  null
  
)

export default component.exports